import React, { useState, useRef, useEffect, useCallback } from 'react';
import { FiSearch, FiMenu } from 'react-icons/fi';
import '../assets/styles/Navbar.css';
import AguasIcon from '../assets/images/aguasIcon.webp';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext/index';
import CartComponent from '../components/CartComponent';
import { searchProductsVector } from '../services/ProductServices';

// const shopItems = [
//   { key: '1', label: 'Categorías', href: '/categories' },
//   { key: '2', label: 'Destacados', href: '/featured' },
 // { key: '3', label: 'Novedades', href: '/new-arrivals' },
// ];

// const pageItems = [
//   { key: '1', label: 'Sobre Nosotros', href: '/about' },
//   { key: '2', label: 'Contáctanos', href: '/contact' },
//   { key: '3', label: 'Preguntas Frecuentes', href: '/faq' },
// ];

export default function Navbar() {
  // const [shopOpen, setShopOpen] = useState(false);
  // const [pagesOpen, setPagesOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [cartCount, setCartCount] = useState(0);
  const [suggestions, setSuggestions] = useState([]);
  const [isSearchingSuggestions, setIsSearchingSuggestions] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const suggestionHideTimeoutRef = useRef(null);
  const suggestionDebounceRef = useRef(null);
  // const shopRef = useRef(null);
  // const pagesRef = useRef(null);
  const navRef = useRef(null);
  const navigate = useNavigate();
  const { userLoggedIn, currentUser, registering } = useAuth(); // Usando el contexto de autenticación

  useEffect(() => {
    function handleClickOutside(event) {
      // if (shopRef.current && !shopRef.current.contains(event.target)) {
      //   setShopOpen(false);
      // }
      // if (pagesRef.current && !pagesRef.current.contains(event.target)) {
      //   setPagesOpen(false);
      // }
      if (navRef.current && !navRef.current.contains(event.target)) {
        setMobileMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchSuggestions = useCallback(async (term) => {
    try {
      const sanitized = term.trim();
      if (!sanitized || sanitized.length < 2) {
        setSuggestions([]);
        setIsSearchingSuggestions(false);
        return;
      }
      setIsSearchingSuggestions(true);
      const response = await searchProductsVector(sanitized, 6);
      setSuggestions(response?.suggestions || []);
    } catch (error) {
      console.error('Error obteniendo sugerencias de búsqueda:', error);
      setSuggestions([]);
    } finally {
      setIsSearchingSuggestions(false);
    }
  }, []);

  useEffect(() => {
    if (!showSuggestions) {
      return undefined;
    }

    if (suggestionDebounceRef.current) {
      clearTimeout(suggestionDebounceRef.current);
    }

    suggestionDebounceRef.current = setTimeout(() => {
      fetchSuggestions(searchTerm.trim());
    }, 300);

    return () => {
      if (suggestionDebounceRef.current) {
        clearTimeout(suggestionDebounceRef.current);
      }
    };
  }, [fetchSuggestions, searchTerm, showSuggestions]);

  useEffect(() => {
    return () => {
      if (suggestionHideTimeoutRef.current) {
        clearTimeout(suggestionHideTimeoutRef.current);
      }
      if (suggestionDebounceRef.current) {
        clearTimeout(suggestionDebounceRef.current);
      }
    };
  }, []);

  const updateCartCount = useCallback(() => {
    const storedItems = localStorage.getItem("cart");
  
    // Safeguard against invalid data or missing cart data
    const cartItems = storedItems ? JSON.parse(storedItems) : [];
  
    // Ensure cartItems is always an array
    if (Array.isArray(cartItems)) {
      const distinctProductCount = new Set(cartItems.map(item => item.id)).size;
      setCartCount(distinctProductCount);
    } else {
      // If the cartItems is not an array, initialize the count to 0
      setCartCount(0);
    }
  }, []);
  
  useEffect(() => {
    updateCartCount();
    window.addEventListener('cartUpdated', updateCartCount);
    return () => {
      window.removeEventListener('cartUpdated', updateCartCount);
    };
  }, [updateCartCount]);

  const handleSearchFocus = () => {
    if (suggestionHideTimeoutRef.current) {
      clearTimeout(suggestionHideTimeoutRef.current);
    }
    setShowSuggestions(true);
    fetchSuggestions(searchTerm.trim());
  };

  const handleSearchBlur = () => {
    suggestionHideTimeoutRef.current = setTimeout(() => {
      setShowSuggestions(false);
    }, 200);
  };

  const handleSuggestionClick = (suggestion) => {
    setShowSuggestions(false);
    if (suggestion?.id) {
      navigate(`/producto/${suggestion.id}`);
      return;
    }

    const suggestionValue = suggestion?.name || searchTerm;
    if (suggestionValue) {
      navigate(`/productos/${encodeURIComponent(suggestionValue)}`);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      setShowSuggestions(false);
      navigate(`/productos/${encodeURIComponent(searchTerm.trim())}`);
    }
  };

  return (
    <div className="layout">
      <header ref={navRef}>
        <div className="top-header">
          <div className={`containernav ${(!userLoggedIn || registering || currentUser?.photoURL === 'vendedor') ? 'not-logged-in' : ''}`}>
            {userLoggedIn && !registering && currentUser?.photoURL !== 'vendedor' && (
              <button className="mobile-menu-button" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                <FiMenu />
              </button>
            )}
            <div className="header-section left">
              <div className="logo">
                <a 
                  href={currentUser?.photoURL === 'vendedor' ? '/profile' : currentUser?.photoURL === 'admin' ? '/admin' : '/'}
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentUser?.photoURL === 'vendedor') {
                      navigate('/profile');
                    } else if (currentUser?.photoURL === 'admin') {
                      navigate('/admin');
                    } else {
                      navigate('/');
                    }
                  }}
                >
                  <img src={AguasIcon} alt="logo mercado del agua" className="icono" />
                  <span className="titulonavbar">mercado del agua</span>
                </a>
              </div>
            </div>
            {userLoggedIn && !registering && currentUser?.photoURL !== 'vendedor' && (
              <div className="header-section center">
                <div className="search-autocomplete">
                  <form onSubmit={handleSearch} className="search-container">
                    <input
                      type="text"
                      placeholder="Buscar productos con IA"
                      className="font"
                      value={searchTerm}
                      onFocus={handleSearchFocus}
                      onBlur={handleSearchBlur}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button type="submit" className="search-button">
                      <FiSearch />
                      <span className="search-text">Buscar</span>
                    </button>
                  </form>
                  {showSuggestions && (
                    <div className="search-suggestions" onMouseDown={(event) => event.preventDefault()}>
                      {isSearchingSuggestions ? (
                        <div className="search-suggestion-status">Buscando productos...</div>
                      ) : suggestions.length > 0 ? (
                        suggestions.map((suggestion) => (
                          <button
                            key={suggestion.id || suggestion.name}
                            type="button"
                            className="suggestion-item"
                            onMouseDown={(event) => event.preventDefault()}
                            onClick={() => handleSuggestionClick(suggestion)}
                          >
                            <FiSearch className="suggestion-icon" />
                            <div className="suggestion-content">
                              <span className="suggestion-title">{suggestion.name || "Producto recomendado"}</span>
                              {suggestion.category && (
                                <span className="suggestion-meta">{`En ${suggestion.category}`}</span>
                              )}
                            </div>
                          </button>
                        ))
                      ) : (
                        <div className="search-suggestion-status">Sin sugerencias disponibles</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className="header-section right">
              <div className="user-actions">
                {userLoggedIn && !registering ? (
                  <div className="user-info" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span
                      className="user-name"
                      style={{ fontSize: '1rem', cursor: 'pointer' }}
                      onClick={() => navigate('/profile')}
                    >
                      {currentUser.displayName || 'Usuario'}

                    </span>
                  </div>
                ) : (
                  <>
                    <a href="/signin" className="sign-in">Iniciar Sesion</a>
                    <a href="/signup" className="sign-up">Registrarse</a>
                  </>
                )}

                {userLoggedIn && !registering && (
                  <>
                    {currentUser?.photoURL !== 'vendedor' ? (
                      <div className="vertical-line"></div>
                    ) : (
                      <div className="vertical-line2"></div>
                    )}

                    {/* Si currentUser.photoURL no es 'vendedor', mostrar el carrito */}
                    {currentUser?.photoURL === 'vendedor' ? (
                      <span
                        className="user-name"
                        style={{ fontSize: '0.8rem', cursor: 'pointer', color: '#5a5a5a' }}
                        onClick={() => navigate('/profile')}
                      >
                        Proveedor
                      </span>
                    ) : (
                      <div>
                        <CartComponent count={cartCount} />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {userLoggedIn && !registering && currentUser?.photoURL !== 'vendedor' && (
          <nav className={`main-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <a 
              href="/" 
              className="subNavb"
              onClick={(e) => {
                e.preventDefault();
                navigate('/');
              }}
            >
              Inicio
            </a>
            <a 
              href="/categories" 
              className="subNavb"
              onClick={(e) => {
                e.preventDefault();
                navigate('/categories');
              }}
            >
              Categorías
            </a>
            <a
              href="/mis-cotizaciones"
              className="subNavb"
              onClick={(e) => {
                e.preventDefault();
                navigate('/mis-cotizaciones');
              }}
            >
              Mis cotizaciones
            </a>
            {/* <div
              className="dropdown-trigger"
              onClick={() => setShopOpen(!shopOpen)}
              ref={shopRef}
            >
              <span className="subNavb">Tienda</span> <FiChevronDown />
              {shopOpen && (
                <div className="dropdown-menu">
                  {shopItems.map((item) => (
                    <a key={item.key} href={item.href}>{item.label}</a>
                  ))}
                </div>
              )}
            </div> */}
            {/*<div
              className="dropdown-trigger"
              onClick={() => setPagesOpen(!pagesOpen)}
              ref={pagesRef}
            >
              <span className="subNavb">Paginas</span> <FiChevronDown />
              {pagesOpen && (
                <div className="dropdown-menu">
                  {pageItems.map((item) => (
                    <a key={item.key} href={item.href}>{item.label}</a>
                  ))}
                </div>
              )}
            </div>*/}
            <a
              href="/ai-agent"
              className="subNavb"
              onClick={(e) => {
                e.preventDefault();
                navigate('/ai-agent');
              }}
            >
              Asistente
            </a>
            <a 
              href="/contact" 
              className="subNavb"
              onClick={(e) => {
                e.preventDefault();
                navigate('/contact');
              }}
            >
              Contáctanos
            </a>
          </nav>
        )}

        {/* Sub-navbar para vendedores */}
        {userLoggedIn && !registering && currentUser?.photoURL === 'vendedor' && (
          <nav className={`main-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <a
              href="/myproducts"
              className="subNavb"
              onClick={(e) => {
                e.preventDefault();
                navigate('/myproducts');
              }}
            >
              Mis Productos
            </a>
            <a
              href="/solicitudes-cotizacion"
              className="subNavb"
              onClick={(e) => {
                e.preventDefault();
                navigate('/solicitudes-cotizacion');
              }}
            >
              Solicitudes de Cotización
            </a>
            <a
              href="/profile"
              className="subNavb"
              onClick={(e) => {
                e.preventDefault();
                navigate('/profile');
              }}
            >
              Mi Perfil
            </a>
          </nav>
        )}
      </header>
    </div>
  );
}
